import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import './TiktokPromo.css';

function TiktokPromo() {
  const cardRef = useRef(null);
  const timelineRef = useRef(null);

  useEffect(() => {
    if (!cardRef.current) return;

    const faces = cardRef.current.querySelector('.faces');
    const hoverPanels = cardRef.current.querySelectorAll('.hover-panel');

    const tl = gsap.timeline({ repeat: -1, repeatDelay: 4 });
    timelineRef.current = tl;

    tl.set(hoverPanels, { autoAlpha: 0, scale: 0.6 });

    tl.to(faces, {
      rotationY: 150,
      rotationX: -5,
      duration: 1,
      ease: 'power1.inOut',
      delay: 1,
    })
      .to(faces, {
        rotationY: 220,
        duration: 3.5,
        ease: 'none',
      })
      .to(
        hoverPanels,
        {
          autoAlpha: 1,
          scale: 1,
          stagger: 0.2,
          ease: 'back.out(2)',
        },
        '-=0.4'
      )
      .to(
        hoverPanels,
        {
          autoAlpha: 0,
          scale: 0.6,
          stagger: 0.15,
          ease: 'power2.in',
        },
        '+=1.4'
      )
      .to(faces, {
        rotationY: 360,
        rotationX: 0,
        duration: 1.4,
        ease: 'elastic.out(0.8, 0.6)',
      });

    return () => {
      tl.kill();
      timelineRef.current = null;
    };
  }, []);

  const handleHoverRestart = () => {
    if (timelineRef.current) {
      timelineRef.current.restart(true, false);
    }
  };

  return (
    <section className="tiktok-promo scroll-fade-in">
      <div className="tiktok-promo__inner">
        <div className="tiktok-promo__copy">
          <p className="promo-kicker">TikTok Campaigns</p>
          <h2>We promote our products on social media as well</h2>
          <p className="promo-lede">
            We created social media posts to analyze the market before working on our application.
          </p>
        </div>

        <div
          className="tiktok-card"
          ref={cardRef}
          onMouseEnter={handleHoverRestart}
        >
          <div className="faces">
            <div className="face front">
              <img
                src="/WebsitePhotos/socialmedia.jpg"
                alt="Social media content"
              />
            </div>
            <div className="face back">
              <img
                src="/WebsitePhotos/socialmedia.jpg"
                alt="Social media content"
              />
              <div className="hover">
                <div className="hover-panel">
                  <span>#mythlabs</span> <span>#astrology</span>
                </div>
                <div className="promo-card__badge promo-card__badge--views">
                  200K <span>views</span>
                </div>
                <div className="promo-card__badge promo-card__badge--likes">
                  5,000 <span>likes</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TiktokPromo;


